import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

export default function CodeSnippet({
  code,
  language = 'bash',
  languages,
  activeLanguage,
  onLanguageChange,
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <div className="relative rounded-xl border border-theme-secondary bg-theme-secondary/20 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-2 border-b border-theme-secondary/60">
        {languages?.length ? (
          <div className="flex items-center gap-3">
            {languages.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => onLanguageChange?.(item.id)}
                className={`text-xs uppercase tracking-wider transition-opacity ${
                  activeLanguage === item.id
                    ? 'opacity-90 font-medium text-theme-primary'
                    : 'opacity-40 hover:opacity-70'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        ) : (
          <span className="text-xs uppercase tracking-wider opacity-50">{language}</span>
        )}
        <button
          type="button"
          onClick={copy}
          className="inline-flex items-center gap-1.5 text-xs opacity-60 hover:opacity-100 transition-opacity"
        >
          {copied ? (
            <>
              <CheckIcon className="h-3.5 w-3.5" />
              Copied
            </>
          ) : (
            <>
              <ClipboardDocumentIcon className="h-3.5 w-3.5" />
              Copy
            </>
          )}
        </button>
      </div>
      <pre className="p-4 text-xs sm:text-sm overflow-x-auto font-mono leading-relaxed">
        <code>{code}</code>
      </pre>
    </div>
  );
}

export function obfuscateKey(prefix) {
  return `${prefix || 'osr_'}${'*'.repeat(12)}`;
}
